module.exports = __webpack_public_path__ + "static/media/title_nextgen.a63cf770.png";